import React from "react";

const DecorativeNumbers = () => {
  return (
    <div>
      <div className="absolute top-8 left-12 text-6xl font-bold text-blue-200/30 transform -rotate-12 select-none">
        33
      </div>
      <div className="absolute top-32 right-16 text-4xl font-bold text-blue-300/40 transform rotate-45 select-none">
        120
      </div>
      <div className="absolute bottom-24 left-8 text-5xl font-bold text-blue-200/35 transform rotate-12 select-none">
        3312
      </div>
      <div className="absolute bottom-16 right-24 text-3xl font-bold text-blue-300/30 transform -rotate-45 select-none">
        0
      </div>
      <div className="absolute top-1/2 left-4 text-2xl font-bold text-blue-200/25 transform -rotate-90 select-none">
        33120
      </div>
      <div className="absolute top-20 right-1/4 text-7xl font-bold text-blue-100/20 transform rotate-12 select-none">
        3
      </div>
      <div className="absolute bottom-1/3 right-8 text-4xl font-bold text-blue-200/30 transform -rotate-12 select-none">
        20
      </div>
      <div className="absolute top-1/3 right-4 text-3xl font-bold text-blue-200/25 transform rotate-75 select-none">
        312
      </div>
    </div>
  );
};

export default DecorativeNumbers;
